import { render, staticRenderFns } from "./ModalTerminosyC.vue?vue&type=template&id=6dfbefdf&scoped=true"
import script from "./ModalTerminosyC.vue?vue&type=script&lang=js"
export * from "./ModalTerminosyC.vue?vue&type=script&lang=js"
import style0 from "./ModalTerminosyC.vue?vue&type=style&index=0&id=6dfbefdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfbefdf",
  null
  
)

export default component.exports